// src/components/QuetionModal.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { TreeSelect, Select, Button, Form, Modal, Input, Row, Col, Upload, AudioFilled, Radio, Textarea, InputNumber, UploadImg } from "../../../../../../templates/my-app/src/components/ui/ot";
import { useTranslation } from 'react-i18next';
import { createContext } from 'react';
import { useContext } from 'react';
import { useRef } from 'react';
import FlowEngine from './FlowEngine';
import { useSOP } from "../controller/sop_controller";
import { v4 as uuidv4 } from 'uuid';


const LanguageContext = createContext(null)

const SOPModal = ({
    keyPrefix = "pmis.sop",
    axiosMode = "post",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => {

    },
    onFinish = () => {

    },
    reloadTable = () => { },
    modalStyle = {},
    openButtonStyle = {
        backgroundColor: "#fff8c8",
        color: "#000"
    },
    openButtontext = "新增標籤分類",
    title = "新增標籤分類",
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const axiosModelanguage = {
        post: t('post'),
        patch: t('edit')
    }
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        onFinish(values)
    }

    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])


    return (<>
        <LanguageContext.Provider value={keyPrefix}>
            {
                propsOpen === null &&
                <Button type="primary" onClick={showModal}>
                    {
                        `${axiosModelanguage[axiosMode]}資料`
                    }
                </Button>
            }

            <Modal
                style={{ top: 10, }}
                contentStyle={{ padding: 16 }}
                // width={1000}
                title={`${axiosModelanguage[axiosMode]}資料`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                okText={t('ok')}
                cancelText={t('cancel')}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
            >
                <Row
                >
                    <Col span={24}>
                        <SOPForm
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                        />
                    </Col>
                </Row>
            </Modal>
        </LanguageContext.Provider>
    </>);
};
export default SOPModal;



const SOPForm = ({
    keyPrefix = "pmis.sop",
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    field,
    fieldName = field?.name,
    hasValue = false,
    axiosMode,
    propsShowKeys = [
        { key: "key", name: "key", hidden: false, require: false },
        { key: "sop_name", name: "sop_name", hidden: false, require: false },
        { key: "person_in_charge", name: "person_in_charge", hidden: false, require: false },
        { key: "average_worktime", name: "average_worktime", hidden: false, require: false },
        { key: "remark", name: "remark", hidden: false, require: false },
        { key: "操作", name: "操作", hidden: false, require: false },
    ],
    customFormItems,
    formMode,
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [currentKey_, setCurrentKey] = useState([])
    const currentKey = propsShowKeys ?? currentKey_;
    const [form] = Form.useForm();
    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        if(axiosMode === "patch") {
            getSOPData({ "sop_id": getAnyFormValue(field?.name+".sop_id")})
            getSOPFormUseData({ "sop_id": getAnyFormValue(field?.name+".sop_id")})
        }
    }
    const onFinish = () => {
        const values = getFormValues();
        // console.log("sop_data")
        // console.log(sop_data)
        if (propsForm) {
            propsForm.setFieldValue(field?.name+'.flow_nodes',(sop_data?.[0]?.flow_nodes) ? sop_data?.[0]?.flow_nodes : [])
            propsForm.setFieldValue(field?.name+'.flow_edges',(sop_data?.[0]?.flow_edges) ? sop_data?.[0]?.flow_edges : [])
        }
        else {
            form.setFieldValue(field?.name+'.flow_nodes',(sop_data?.[0]?.flow_nodes) ? sop_data?.[0]?.flow_nodes : [])
            form.setFieldValue(field?.name+'.flow_edges',(sop_data?.[0]?.flow_edges) ? sop_data?.[0]?.flow_edges : [])
        }
        onFormFinish({
            ...values,
            flow_nodes: (sop_data?.[0]?.flow_nodes) ? sop_data?.[0]?.flow_nodes : [],
            flow_edges: (sop_data?.[0]?.flow_edges) ? sop_data?.[0]?.flow_edges : [],
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        if (fieldName) {
            if (propsForm) {
                formValues = propsForm.getFieldValue(fieldName)
            }
            else {
                formValues = form.getFieldValue(fieldName)
            }
        } else {
            if (propsForm) {
                formValues = propsForm.getFieldsValue()
            }
            else {
                formValues = form.getFieldsValue()
            }
        }
    }

    const getAnyFormValue = (name, count = 0) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };

    const {
        SOPData, 
        getSOPData,
        SOPFormUseData, 
        getSOPFormUseData, 
    } = useSOP({});

    useEffect(() => {
        setDataInitialization();
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])
    useEffect(() => {
        set_sop_data(SOPData)
    }, [SOPData])











    const [sop_data, set_sop_data] = useState([])
    const [current_sop_key, set_current_sop_key] = useState(0);

    const handleFlowNodesChange = (nodes) => {
        if(sop_data.length !== 0) {
            if(sop_data?.[0]?.flow_nodes.length !== nodes.length) {
                set_sop_data(prevData => 
                    prevData.map(prevObject => ({ 
                        ...prevObject, 
                        flow_nodes: nodes
                    }))
                )
            }
        }
    }
    const handleFlowNodesPositionChange = (nodes) => {
        set_sop_data(prevData => 
            prevData.map(prevObject => ({ 
                ...prevObject, 
                flow_nodes: prevObject.flow_nodes.map(prevNode => 
                    prevNode.id === nodes.id
                    ? { 
                        ...prevNode, 
                        position: nodes.position
                    }
                    : prevNode)
            }))
        )
    }
    const handleFlowEdgesChange = (edges) => {
        set_sop_data(prevData => 
            prevData.map(prevObject => ({ 
                ...prevObject, 
                flow_edges: edges
            }))
        )
    }
    const handleFlowNodeSelect = (data) => {
        // console.log("data")
        // console.log(data)
    }

    // 新增、刪除步驟的按鈕群組中新增的觸發事件
    const handleAddStepClick = () => {
        let node_id = uuidv4()
        let new_node = {
            id: node_id,
            data: { label: '' },
            position: { x: 0, y: 0 },
            flow_step_id: node_id,
        }
        if(sop_data.length === 0) {
            set_sop_data([
                {
                    sop_name: "",
                    person_in_charge: "",
                    average_worktime: "",
                    remark: "",
                    flow_nodes: [
                        new_node,
                    ],
                    flow_edges: [],
                }
            ])
        }
        else {
            set_sop_data(prevData => 
                prevData.map(prevObject => ({ 
                    ...prevObject, 
                    flow_nodes: [
                        ...prevObject.flow_nodes,
                        new_node
                    ]
                }))
            )   
        }
    }


    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Form.Item
                                        hidden={true}
                                        name={fieldName ? [fieldName, "sop_id"].join('.') : "sop_id"}

                                    >
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={t('sop_name')}
                                        name={fieldName ? [fieldName, "sop_name"].join('.') : "sop_name"}
                                        rules={!hasValue ? [
                                            {
                                                required: currentKey?.find((element) => {
                                                    return element.name === "sop_name"
                                                })?.require,
                                                message: "請輸入"
                                            }
                                        ] : []}
                                    >
                                        <Input disabled={hasValue} />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={t('person_in_charge')}
                                        name={fieldName ? [fieldName, "person_in_charge"].join('.') : "person_in_charge"}
                                        rules={!hasValue ? [
                                            {
                                                required: currentKey?.find((element) => {
                                                    return element.name === "person_in_charge"
                                                })?.require,
                                                message: "請輸入"
                                            }
                                        ] : []}
                                    >
                                        <Input disabled={hasValue} />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={t('average_worktime')}
                                        name={fieldName ? [fieldName, "average_worktime"].join('.') : "average_worktime"}
                                        rules={!hasValue ? [
                                            {
                                                required: currentKey?.find((element) => {
                                                    return element.name === "average_worktime"
                                                })?.require,
                                                message: "請輸入"
                                            }
                                        ] : []}
                                    >
                                        <Input disabled={hasValue} />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={t('remark')}
                                        name={fieldName ? [fieldName, "remark"].join('.') : "remark"}
                                        rules={!hasValue ? [
                                            {
                                                required: currentKey?.find((element) => {
                                                    return element.name === "remark"
                                                })?.require,
                                                message: "請輸入"
                                            }
                                        ] : []}
                                    >
                                        <Input disabled={hasValue} />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={t('flow')}
                                        name={fieldName ? [fieldName, "flow_nodes"].join('.') : "flow_nodes"}
                                        rules={!hasValue ? [
                                            {
                                                required: currentKey?.find((element) => {
                                                    return element.name === "flow_nodes"
                                                })?.require,
                                                message: "請輸入"
                                            }
                                        ] : []}
                                        // rules={!hasValue ? [
                                        //     {
                                        //         required: true,
                                        //         message: "請輸入"
                                        //     }
                                        // ] : []}
                                    >
                                        <>
                                        <Button
                                            type={'primary'}
                                            onClick={() => handleAddStepClick()}
                                        >
                                            {t('post_step')}
                                        </Button>
                                        <FlowEngine 
                                            // custom_nodes={[]}
                                            // custom_edges={[]}
                                            custom_nodes={sop_data?.[0]?.flow_nodes}
                                            custom_edges={sop_data?.[0]?.flow_edges}
                                            onFlowNodesChange={(nodes) => handleFlowNodesChange(nodes)}
                                            onFlowEdgesChange={(edges) => handleFlowEdgesChange(edges)}
                                            onFlowNodeSelect={(click_data) => {
                                                handleFlowNodeSelect(click_data)
                                            }}
                                            onFlowNodePositionChange={(nodes) => {
                                                handleFlowNodesPositionChange(nodes)
                                            }}
                                        /> 
                                        </>
                                    </Form.Item>
                                </Col>
                            </Row>
                            {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form, field)}
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
export { SOPForm }